import { useModalContext, TableColumn, Button } from '@ally/metronome-ui';
import { muiAllyTheme } from '../../../utils';
import { Modal, Table } from '../../molecules';

interface IProps<T extends object> {
  children?: React.ReactNode;
  data: T[];
  columns: TableColumn<T>[];
  captionText?: string;
}

// This needs to be a separate component so that it can grab the parent modal context from it's parent modal component
const ModalTrigger: React.FC = () => {
  const { setOpen, open } = useModalContext();

  return (
    <Button
      allytmln='tableViewNetWorthPerformance'
      variant='link'
      text='Table View'
      marginLeft='auto'
      onClick={() => setOpen(!open)}
    />
  );
};

const TableViewModal = <T extends object>(props: IProps<T>) => {
  return (
    <Modal
      heading='Table View'
      headingProps={{
        color: muiAllyTheme.colors['plum-700'],
        fontSize: '1.6rem',
        fontWeight: 'normal',
      }}
      content={
        <Table
          config={{ data: props.data, columns: props.columns }}
          shared={{ captionText: props.captionText || '' }}
          table={{ caption: { isVisible: false } }}
        />
      }
      trigger={<ModalTrigger />}
    />
  );
};

export default TableViewModal;
